import React, { useState, useContext, useCallback } from "react";
import { Dimensions, StyleSheet, View, Image, Text } from "react-native";

import Col from "~/layouts/Col";
import IconNavLink from "~/components/Buttons/IconNavLink";
import palette from "~/styles/palette";
import { BadgeContext } from "~/contexts/BadgeContext";

import useTwilio from "~/hooks/useTwilio";

export default function SidePanel() {
  const compactMode = Dimensions.get("window").width < 960;
  const { calls, messages, voicemails } = useContext(BadgeContext);

  const { activeCall } = useTwilio();

  if (compactMode) return null;

  return (
    <Col maxWidth={95} style={[styles.side_panel__container]}>
      <View style={{ flex: 1 }}>
        <LogoButton />
        <IconNavLink
          vertical
          iconName="message-circle"
          to="/messages"
          badge={messages}
        />
        <IconNavLink
          vertical
          iconName="phone"
          to="/calls"
          badge={calls}
          bgOverride={activeCall ? palette.success : null}
        />
        <IconNavLink vertical iconName="users" to="/customers" />
        <IconNavLink
          vertical
          iconName="voicemail"
          to="/voicemails"
          badge={voicemails}
        />
        <IconNavLink vertical iconName="settings" to="/settings" />
      </View>
      <View style={{ flexDirection: "column", alignItems: "flex-end" }}>
        <IconNavLink vertical iconName="log-out" to="/logout" />
      </View>
    </Col>
  );
}

const LogoButton = () => {
  return (
    <View style={[styles.side_panel__logo_container]}>
      <Image
        source={require("~/assets/logo-icon-trans.png")}
        style={[styles.side_panel__logo]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  side_panel__container: {
    borderRightWidth: 0,
    // borderRightColor: "#eee",
    height: "100%",
    backgroundColor: palette.primary_dark,
  },
  side_panel__logo_container: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 6,
    marginVertical: 10,
  },
  side_panel__logo: {
    height: 45,
    width: 45,
  },
});
